import { Grid, Stack } from "@mui/material";
import React, { useEffect } from "react";
import CardOwnView from "./CardOwnView";

function ContainerCardsOwn({
  setPaginatedData,
  data,
  columns,
  childSizes,
  types,
  editButton = false,
  detailsButton = false,
  deleteButton = false,
  showVerified = false,
}) {
  return (
    <Stack>
      <Grid container columns={columns} spacing={3}>
        {(data || []).map((element, index) => {
          return (
            <CardOwnView
              editButton={editButton}
              detailsButton={detailsButton}
              deleteButton={deleteButton}
              showVerified={showVerified}
              types={types}
              dataCard={element}
              key={index}
              sizeXS={childSizes.xs}
              sizeSM={childSizes.sm}
              sizeMD={childSizes.md}
              sizeLG={childSizes.lg}
              setPaginatedData={setPaginatedData}
            />
          );
        })}
      </Grid>
    </Stack>
  );
}

export default ContainerCardsOwn;
